<ng-container *ngIf="enterpriseClient; else showProspectDashboard">
  <app-byob-dashboard></app-byob-dashboard>
</ng-container>
<ng-template #showProspectDashboard>
  <div class="flex flex-col items-center byob-dashboard-wrapper max-width-lg pt-70">
    <div class="flex flex-row mb-22">
      <section class="flex justify-center items-center dashboard">
        <div class="linear">
          <div class="mat-headline-1 welcome fw-500">{{ 'BYOB_DASHBOARD.WELCOME' | transloco }}</div>
          <div class="mat-body-2">{{ 'BYOB_DASHBOARD.DESCRIPTION' | transloco }}</div>
          <div class="flex flex-row mt-50">
            <button *ngIf="permissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="flex items-center mossgreen mr-12" (click)="goToComposeService()">
              <mat-icon svgIcon="add" class="icon-md mr-12"></mat-icon>
              {{ 'BYOB_DASHBOARD.COMPOSE_SERVICE' | transloco }}</button>
            <!-- <button class="transparent cursor-pointer" (click)="goToReadMore()">{{ 'BYOB_DASHBOARD.READ_MORE' | transloco }}</button> -->
          </div>
          <img src="/assets/images/banner-border-new.png" class="border">
        </div>
      </section>
    </div>
    <div class="flex flex-row mb-50">
      <app-byob-my-services class="w-75-percent"></app-byob-my-services>
      <div class="flex flex-col w-25-percent white-bg ml-20 upgrade-enterprise">
        <img src="/assets/images/Upgrade_Enterprise.png" class="w-max-percent">
        <div class="flex flex-col p-20">
          <div class="mat-headline-5 fw-700">{{ 'BYOB_DASHBOARD.UPGRADE_ENTERPRISE' | transloco }}</div>
          <div class="basis-full mat-subtitle-2">
            {{ 'BYOB_DASHBOARD.ENTERPRISE_DESCRIPTION' | transloco }}
          </div>
          <div class="flex flex-row justify-end">
            <div class="mat-subtitle-2 fw-700 ml-auto cursor-pointer mb-0">
              <a (click)="openContactForm()" class="fs-16 fw-700 mr-10 cursor-pointer mat-caption border-none">{{ 'BYOB_DASHBOARD.CONTACT_SALES' | transloco }}</a>
            </div>
            <mat-icon svgIcon="chevron_right" class="icon icon-sm mt-4 ml-2 cursor-pointer"></mat-icon>
          </div>
        </div>
      </div>
    </div> 
    <div class="max-width-lg learn-sass pt-50 hidden">
      <app-learn-saas></app-learn-saas>
    </div>
  </div>
</ng-template>
